<template>
  <v-container class="new-onboarding white py-5" fill-height fluid>

    <v-row v-if="!doOnboarding" align="center" class="fill-height" no-gutters>
      <v-col cols="12" md="10" offset-md="1" offset-xl="2" xl="8">
        <v-card color="transparent">
          <v-card-text class="text-h5 primary--text text-md-h4
                        text-xl-h3 text-wrap font-weight-bold
                        text-left px-5 pt-0 pb-8"
          >
            {{ $t('onboarding.lander_title') }}
          </v-card-text>
        </v-card>
        <v-card color="transparent">
          <v-card-text class="text-md-h5 text-subtitle-1 content text-left px-5 pt-0">
            <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''">
              {{ $t('onboarding.lander_explanation') }}
            </p>
            <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''"
               class="text-md-h6 text-body-1 grey--text text--darken-1">
              {{ $t('onboarding.lander_analysis_explanation') }}
            </p>
            <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''"
               class="text-md-h6 text-body-1 grey--text text--darken-1">
              {{ $t('onboarding.lander_team_explanation') }}
            </p>
            <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''"
               class="text-md-h6 text-body-1 grey--text text--darken-1">
              {{ $t('onboarding.lander_task_explanation') }}
            </p>
          </v-card-text>
          <v-card-text>
            <v-btn :x-large="$vuetify.breakpoint.mdAndUp" class="mt-10 mr-5" depressed outlined rounded
                   @click="skipButton">{{ $t('onboarding.skip_onboarding_button') }}
            </v-btn>
            <v-btn :x-large="$vuetify.breakpoint.mdAndUp" class="mt-10" color="primary" rounded
                   @click="doOnboarding = true">{{ $t('onboarding.start_onboarding_button') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="doOnboarding && !apiErrors" align="center" class="fill-height" no-gutters>
      <v-col v-if="!loading" cols="12" md="10" offset-md="1" offset-xl="2" xl="8">
        <v-row align="start" no-gutters>
          <v-col cols="12">
            <v-card color="transparent">
              <v-card-text class="text-h5 primary--text text-md-h4
                        text-xl-h3 text-wrap font-weight-bold
                        text-left px-5 pt-0 pb-8"
              >
                {{ $t('onboarding.header') }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row align="start" class="fill-height" no-gutters>
          <v-col cols="12"
                 lg="6"
                 md="12">
            <v-card color="transparent">
              <v-card-text class="text-md-h5 text-subtitle-1 content text-left px-5 pt-0">
                <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''">{{ $t('onboarding.description') }}
                </p>
                <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''">{{ $t('onboarding.actions_instruction') }}
                </p>
                <p :class="$vuetify.breakpoint.xl?'text-weight-bold py-2':''">{{ $t('onboarding.actions_note') }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="6" md="12">
            <v-row>
              <v-col cols="12" sm="6">
                <v-card class="d-flex flex-column personnel-card rounded-xl fill-height">
                  <v-card-title class="font-weight-bold text-h5 text-lg-h6 text-sm-h6 px-5">{{
                      $t('surveys.type.PERSONNEL')
                    }}
                    <v-spacer/>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="black" justify="end" v-bind="attrs" v-on="on">mdi mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <p class="text-h6 pt-3">{{ $t('surveys.type.PERSONNEL') }}</p>
                      <p class="text-body-1">{{ $t('surveys.personnel_survey_explained') }}</p>
                      <p
                        class="text-body-1 font-weight-bold">{{
                          $t('surveys.personnel_survey_explained2')
                        }}</p>
                    </v-tooltip>
                  </v-card-title>
                  <v-card-text class="px-5 text-subtitle-1">{{
                      $t('onboarding.personnel.description')
                    }}
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <v-card-text class="flex-column">
                    <v-btn block class="mx-0 my-1" color="white" rounded
                           @click="getShareLink('PERSONNEL', 'PERSONNEL')">
                      {{ $t('onboarding.copy_link') }}
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6">
                <v-card class="d-flex flex-column management-card rounded-xl fill-height">
                  <v-card-title class="font-weight-bold text-h5 text-lg-h6 text-sm-h6 px-5 white--text">{{
                      $t('surveys.type.MANAGEMENT')
                    }}
                    <v-spacer/>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="white" justify="end" v-bind="attrs" v-on="on">mdi mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <p class="text-h6 pt-3">{{ $t('surveys.type.MANAGEMENT') }}</p>
                      <p class="text-body-1">{{ $t('surveys.management_survey_explained') }}</p>
                      <p class="text-body-1 font-weight-bold">
                        {{ $t('surveys.management_survey_explained2') }}</p>
                    </v-tooltip>
                  </v-card-title>
                  <v-card-text class="px-5 text-subtitle-1 white--text">{{
                      $t('onboarding.management.description')
                    }}
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <v-card-text class="flex-column">
                    <v-btn block class="mx-0 my-1" rounded @click="getShareLink('MANAGEMENT', 'MANAGEMENT')">
                      {{ $t('onboarding.copy_link') }}
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="!$isPaidTenant" no-gutters>
              <v-col class="text-center grey--text text--darken-1 text-body-1 text-lg-h6 mt-5 mx-4" cols="12">
                {{ $t('onboarding.free_tier_limitation_text') }}
              </v-col>
            </v-row>
            <v-row justify="end" no-gutters>
              <v-btn class="mt-10" color="primary" rounded x-large
                     @click="readyButton">{{ $t('onboarding.onboarding_complete_button') }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <loading-indicator v-else></loading-indicator>
    </v-row>
    <no-content-view v-else
                     :description="$t('onboarding.api_errors_desc')"
                     :description-extra="$t('onboarding.api_errors_desc_extra')"
                     :function-button="true"
                     :function-button-text="$t('onboarding.api_errors_button_text')"
                     :prop-function="onboardingEngine"
                     :reload-button="false"
                     :title="$t('onboarding.api_errors_dialog_title')"
                     function-button-icon="mdi-reload"
    ></no-content-view>
  </v-container>
</template>

<script>
/* eslint-disable */
import surveyApi from "@/api/survey";
import dayjs from "dayjs";
import teamApi from "@/api/team";
import staticTaskApi from "@/api/statictask";
import taskApi from "@/api/task";
import pLimit from 'p-limit';
import _ from 'lodash'
import NoContentView from "@/components/NoContentView.vue";
import surveyShareApi from "@/api/surveyshare";
import LoadingIndicator from "@/components/LoadingIndicator";
/* eslint-enable */

export default {
  name: "SimpleOnboardingView",
  components: {NoContentView, LoadingIndicator},
  data() {
    return {
      loading: true,
      doOnboarding: false,
      showProgress: false,
      apiErrors: true,
      progress: 'Loading...',
      types: ['PERSONNEL', 'MANAGEMENT'],
      teams: [],
      surveys: [],
      surveysDuration: 5,
      surveyShares: [],
      suggestedTasks: [],
    }
  },
  methods: {
    shouldSkipOnboarding() {
      return (this.checkSurveys() || this.checkTeams() || this.checkTasks()) || false;
    },
    async checkSurveys() {
      this.progress = 'Checking for surveys...';
      try {
        const checkForSurveysHelper = await surveyApi.getSurveys();
        if (checkForSurveysHelper.find((s) => this.types.includes(s.surveyTemplate.type))) {
          return true;
        }
      } catch (e) {
        this.apiErrors = true;
        console.log(e);
      }
      return false;
    },
    async checkTeams() {
      this.progress = 'Checking for teams...';
      try {
        const checkForTeamsHelper = await teamApi.getTeams();
        if (checkForTeamsHelper.find((team) => this.types.includes(team.type))) {
          return true;
        }
      } catch (e) {
        this.apiErrors = true;
        console.log(e);
      }
      return false;
    },
    async checkTasks() {
      this.progress = 'Checking for tasks...';
      try {
        const checkForTasksHelper = await taskApi.getTasks();
        if (checkForTasksHelper.find(t => t.type === 'personnel_help' || t.type === 'management_help')) {
          return true;
        }
      } catch (e) {
        this.apiErrors = true;
        console.log(e);
      }
      return false;
    },
    async onboardingEngine() {
      this.apiErrors = false;
      this.loading = true;
      // this.showProgress = true;

      if (await this.shouldSkipOnboarding() === true) {
        await this.$router.replace({name: 'tenant_start'});
        return;
      }

      await this.getSuggestedTasks();

      const personnelTeam = await this.createTeams('PERSONNEL');
      const managementTeam = await this.createTeams('MANAGEMENT');

      const personnelSurvey = await this.createSurveys('PERSONNEL');
      const managementSurvey = await this.createSurveys('MANAGEMENT');

      if (personnelSurvey) {
        await this.createSurveyShares(personnelSurvey, personnelTeam);
      }
      if (managementSurvey) {
        await this.createSurveyShares(managementSurvey, managementTeam);
      }


      await this.generateTasks();

      this.progress = 'All done!';
      this.loading = false;
      // this.showProgress = false;
    },
    async createSurveys(type) {
      this.progress = 'Creating analyses...'

      const survey = {
        type: null,
        start: dayjs().format('YYYY-MM-DD'),
        end: dayjs().add(this.surveysDuration, 'days').format('YYYY-MM-DD'),
        notifications: null,
        estimatedAnswerers: null,
        name: null
      };
      let surveyResponse = null;
      try {
        surveyResponse = await surveyApi.createSurvey({
          ...survey,
          type: type,
          start: dayjs(survey.start).set('hour', 0).set('minute', 0).set('second', 0).toISOString(),
          end: dayjs(survey.end).set('hour', 23).set('minute', 59).set('second', 59).toISOString(),
          notifications: 'WEEKLY',
          estimatedAnswerers: 10,
          name: ''
        })
        this.surveys.push(surveyResponse);
      } catch (e) {
        console.log('Surveys creation error:', e.message);
      }
      return surveyResponse;
    },
    async createTeams(type) {
      this.progress = 'Creating teams...';

      const team = {
        type: type,
        name: _.startCase(_.toLower(this.$t('teams.types.' + type))),
        description: '',
        answerers: [],
      };
      let teamResponse = null;

      try {
        teamResponse = await teamApi.createTeam(team)
        this.teams.push(teamResponse);
      } catch (e) {
        console.error(e);
      }
      return teamResponse;

    },
    async createSurveyShares(survey, team) {

      const surveyShare = await surveyShareApi.createSurveyShare({
        name: team.name,
        surveyKey: survey.key,
        answerers: 10,
        teams: [team],
      })
      this.surveyShares.push(surveyShare);
    },
    async getShareLink(surveyType, teamType) {
      const survey = this?.surveys.find(s => s.surveyTemplate.type === surveyType);
      const team = this?.teams.find(t => t.type === teamType);
      const share = this.surveyShares?.find(sh => sh.surveyKey === survey?.key && sh?.teams.some((team) => teamType === team.type))

      if (this.surveyShares) {
        try {
          await this.$copyText(this.getLink(share, team));
          this.$showSuccessNotification(this.$t('surveys.link_copied'));
        } catch (e) {
          console.error(e);
        }
        return false;
      }

      this.surveyShares = await this.getSurveyShares();

      try {

        await this.$copyText(this.getLink(share));
        this.$showSuccessNotification(this.$t('surveys.link_copied'));

      } catch (e) {
        this.apiErrors = true;
        console.error(e);
      }
    },
    getLink(surveyShare, team) {
      return `${window.location.origin}/public/#/s/${surveyShare?.key}${this.$tenant}/${team.urlSafeName}`
    },
    async generateTasks() {
      this.progress = 'Generating tasks...';

      try {
        const limit = pLimit(3);
        const promises = [];
        for (let suggestedTask of this.suggestedTasks) {
          promises.push(
            limit(async () => {
              try {
                const t = {
                  staticTaskId: suggestedTask.id,
                  type: suggestedTask.type,
                  name: suggestedTask.nameText,
                  description: suggestedTask.descriptionText,
                  priority: suggestedTask.priority,
                  category: null,
                  dueDate: dayjs().add(30, 'days').format('YYYY-MM-DD'),
                };
                await taskApi.createTask(t);
              } catch (e) {
                console.error(e);
              }
            })
          );
        }
        await Promise.all(promises);
      } catch (e) {
        console.error(e);
      }
    },
    async getSuggestedTasks() {
      this.progress = 'Fetching suggested tasks...'
      try {
        let tasks = await staticTaskApi.getStaticTasks();
        tasks = tasks.map(task => {
          task.searchString = `${task.nameText} ${task.descriptionText}`;
          return task;
        });
        this.suggestedTasks = tasks.filter((t) => {
          return ['management_help', 'personnel_help'].includes(t.type);
        });
      } catch (e) {
        console.error(e);
      }
    },
    readyButton() {
      this.$router.replace({name: 'tenant_start', params: {onboardingSuccess: true}});
    },
    skipButton() {
      this.$router.replace({name: 'tenant_start', params: {onboardingSuccess: false}});
    }
  },
  watch: {
    doOnboarding(val) {
      if (val) {
        this.onboardingEngine();
      }
    }
  },
  async mounted() {
    this.tenant = this.$tenant
  }
}
</script>

<style scoped>
.personnel-card {
  background: rgb(249, 238, 231);
  background: linear-gradient(87deg, rgba(249, 238, 231, 1) 0%, rgba(240, 188, 174, 1) 49%, rgba(241, 98, 65, 1) 90%);
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 4px;
}

.management-card {
  background: rgb(113, 148, 255);
  background: linear-gradient(87deg, rgba(113, 148, 255, 1) 0%, rgba(113, 148, 255, 1) 16%, rgba(0, 0, 201, 1) 100%);
}
</style>
